export enum Species {
    // Core
    Andorian,
    Bajoran,
    Betazoid,
    Denobulan,
    Human,
    Tellarite,
    Trill,
    Vulcan,
    // Extended
    KlingonExt,
    RomulanExt,
    Borg,
    FerengiExt,
    CardassianExt,
    JemHadar,
    Vorta,
    // Beta Quadrant
    Ardanan,
    Benzite,
    Bolian,
    Deltan,
    Efrosian,
    Klingon,
    Chelon,
    Jelna,
    Risian,
    XindiArboreal,
    XindiPrimate,
    XindiReptilian,
    XindiInsectoid,
    Zakdorn,
    Reman,
    Orion,
    GornExt,
    // DS9
    Changeling,
    Ferengi,
    // TNG
    Android,
    // Alpha Quadrant
    Arbazan,
    Arkarian,
    Aurelian,
    Caitian,
    Cardassian,
    Edosian,
    FerengiAlpha,
    Grazerite,
    Haliian,
    Ktarian,
    Zaranite,
    // Gamma Quadrant
    Argrathi,
    ChangelingGamma,
    Dosi,
    Drai,
    Karemma,
    Lurian,
    Paradan,
    Rakhari,
    Skreeaa,
    SonA,
    Tosk,
    Wadi,
    // Delta Quadrant
    Ankari,
    Jye,
    LiberatedBorg,
    Lokirrim,
    Mari,
    Monean,
    Ocampa,
    Pendari,
    Sikarian,
    Talaxian,
    Turei,
    Zahl,
    // Voyager
    Hologram,
    // Klingon Core
    KlingonQuchHa,
    // Shakleton Expanse
    Akaru,
    CalMirran,
    Qofuari,
    VinShari,
    // IwdYearFive
    IQosa,
    Iotian,
    Tholian,


    // Tribble Player Character
    Tribble,

    // Discovery
    Kelpien,
    Barzan,
    Osnullus,
    Xahean,
    Saurian,
    CyberneticallyEnhanced,

    // should have been in Delta Quadrant, above...
    Kobali,
    Romulan,

    // Lower Decks
    Apergosian,
    Cetacean,
    Clicket,
    Exocomp,
    Gorn,
    Kaelon,
    Pakled,
    Tamarian,
    Kzinti,
    Anabaj,

    // Captain's Log
    Aenar,
    Bynar,
    Doopler,
    Horta,
    Illyrian,
    Kazon,
    Suliban,


    Custom,
};